/**
 * Landingspagina in `public/landing/`.
 * Patroon: `*-light.png` voor licht thema; basisbestand (zonder `-light`) voor donker.
 * Optioneel expliciet `dark:` als je een ander pad dan `src` wilt.
 */
export type LandingImageSlot =
  | 'hero'
  | 'comfortProblem'
  | 'featureThermal'
  | 'featureRooms'
  | 'featureReport';

export type LandingImagePaths = {
  /** Donker thema (en fallback als light ontbreekt) */
  src: string;
  /** Licht thema */
  light?: string;
  dark?: string;
};

export const LANDING_IMAGE_PATHS: Record<LandingImageSlot, LandingImagePaths> = {
  hero: {
    src: '/landing/landing-hero-visual.png',
    light: '/landing/landing-hero-visual-light.png',
  },
  comfortProblem: {
    src: '/landing/landing-comfort-problem-radiator.png',
    light: '/landing/landing-comfort-problem-radiator-light.png',
  },
  featureThermal: {
    src: '/landing/landing-feature-thermal.png',
    light: '/landing/landing-feature-thermal-light.png',
  },
  featureRooms: {
    src: '/landing/landing-feature-rooms.png',
    light: '/landing/landing-feature-rooms-light.png',
  },
  featureReport: {
    src: '/landing/landing-feature-report.png',
    light: '/landing/landing-feature-report-light.png',
  },
};

export function resolveLandingImageUrl(
  paths: LandingImagePaths,
  scheme: 'light' | 'dark'
): string {
  if (scheme === 'light' && paths.light) return paths.light;
  if (scheme === 'dark' && paths.dark) return paths.dark;
  return paths.src;
}
